// extracted by mini-css-extract-plugin
export var container = "index-module--container--3sZI8";
export var textContainer = "index-module--textContainer--15b3u";
export var infoLine = "index-module--infoLine--CVfvb";